import { Modal, ModalBody } from '@customerio/pluma-components/react';
import { setPlumaModalSize } from '@/features/design-studio/shared';
import { AddPeopleActions } from './add-people-actions';

type AddPeopleModalProps = {
  isOpen: boolean;
  onClose: () => void;
  /**
   * Hides the integrations grid and swaps the manual section's lead-in, for
   * Builder-plan accounts.
   */
  isBuilder?: boolean;
  /** Fired with the card's title (or `'Other'` for the untitled catch-all card). */
  onActionClick: (title: string) => void;
};

/**
 * The add-people catalog in a modal, opened from the Profiles list. Renders the
 * same catalog as the full-page `/profiles/create`, so the two entry points can
 * never drift apart.
 *
 * The catalog's cards are wider than Pluma's `md` preset allows, so the minimum
 * width is set through the modal's own CSS custom property.
 */
export function AddPeopleModal({ isOpen, onClose, isBuilder = false, onActionClick }: AddPeopleModalProps) {
  return (
    <Modal title="Add people" isOpen={isOpen} onClose={onClose} style={setPlumaModalSize({ minWidth: '980px' })}>
      <ModalBody>
        <AddPeopleActions isBuilder={isBuilder} onActionClick={onActionClick} />
      </ModalBody>
    </Modal>
  );
}
